import React from 'react';
import { render } from 'react-dom';

import { App } from './app';

// Enable HMR in development.
if (process.env.NODE_ENV !== 'production' && module.hot) {
  module.hot.accept();
}

const root = document.getElementById('root');
const state = JSON.parse(root.getAttribute('data-state'));
if (process.env.NODE_ENV === 'production') {
  root.removeAttribute('data-state');
}

// Set Sentry up on Errors only. This allows us to only import the
// (quite large) Sentry module when there is an error to report.
function captureError(error) {
  if (process.env.NODE_ENV === 'production') {
    import(/* webpackChunkName: "sentry" */ '@sentry/browser').then(Sentry => {
      Sentry.init({
        dsn: state.env.SENTRY_BROWSER_DSN,
        integrations: integrations =>
          integrations.filter(int => int.name !== 'GlobalHandlers'),
      });

      Sentry.captureException(error);
    });
  } else {
    console.log('Error not reported to Sentry in development');
    console.error(error); // eslint-disable-line no-console
  }
}
window.onerror = (message, url, line, column, error) => captureError(error);
window.onunhandledrejection = event => captureError(event.reason);

render(<App initialState={state} />, root);
